module.exports = __webpack_public_path__ + "img/basilurr.d06a3ea8.svg";